var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoMedicine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 160,
    viewBox: "0 0 200 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "nw1pu6nwba",
    d: "M0 115.197L155.897 115.197 155.897 0 0 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H200V160H0z",
    transform: "translate(-1230 -877) translate(32 22) translate(1198 855)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.439,
    transform: "translate(-1230 -877) translate(32 22) translate(1198 855) translate(37 28)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCECDB",
    d: "M69.245 6.269v56.177c0 3.447-2.82 6.269-6.268 6.269H29.586c-.893 0-1.744-.19-2.516-.53-2.204-.975-3.753-3.185-3.753-5.739V6.27C23.317 2.819 26.14 0 29.586 0h33.39c3.45 0 6.27 2.82 6.27 6.269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M54.454 21.125c-3.53-1.325-5.314-5.259-3.99-8.786 1.325-3.528 5.258-5.315 8.787-3.99 3.528 1.325 5.314 5.26 3.99 8.787-1.325 3.527-5.26 5.314-8.787 3.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M63.24 17.136l-12.775-4.797c1.324-3.528 5.257-5.315 8.786-3.99 3.528 1.325 5.314 5.26 3.99 8.787"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M31.395 20.023c-2.92-2.384-3.353-6.682-.97-9.6 2.382-2.92 6.68-3.355 9.6-.971 2.919 2.382 3.354 6.682.97 9.6-2.382 2.92-6.681 3.354-9.6.971"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M40.996 19.052l-10.572-8.63c2.383-2.919 6.68-3.354 9.601-.97 2.919 2.382 3.354 6.682.97 9.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M54.454 62.75c-3.53-1.326-5.314-5.26-3.99-8.787 1.325-3.527 5.258-5.314 8.787-3.99 3.528 1.325 5.314 5.26 3.99 8.787-1.325 3.528-5.26 5.314-8.787 3.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M63.24 59.224l-12.775-4.797c1.324-3.528 5.257-5.315 8.786-3.99 3.528 1.325 5.314 5.26 3.99 8.787"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M31.395 61.648c-2.92-2.385-3.353-6.683-.97-9.601 2.382-2.92 6.68-3.355 9.6-.971 2.919 2.383 3.354 6.682.97 9.6-2.382 2.92-6.681 3.354-9.6.972"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M40.996 61.14l-10.572-8.63c2.383-2.919 6.68-3.355 9.601-.97 2.919 2.382 3.354 6.682.97 9.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M59.775 42.49c-3.407 1.615-7.475.161-9.088-3.243-1.614-3.405-.163-7.474 3.243-9.089 3.405-1.613 7.475-.16 9.089 3.244 1.613 3.405.16 7.475-3.244 9.088"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M63.019 33.402l-12.332 5.845c-1.614-3.405-.163-7.474 3.243-9.089 3.405-1.613 7.475-.16 9.089 3.244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M29.375 33.789c1.401-3.5 5.373-5.2 8.87-3.8 3.499 1.4 5.2 5.37 3.8 8.87-1.4 3.499-5.372 5.2-8.87 3.8-3.498-1.4-5.2-5.372-3.8-8.87"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M33.175 42.66l5.07-12.67c3.499 1.4 5.2 5.37 3.8 8.87-1.4 3.498-5.372 5.2-8.87 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M69.245 13.957v48.885c0 3.23-2.58 5.873-5.736 5.873H32.955c-.817 0-1.596-.177-2.302-.498V20.724c0-1.942.81-3.7 2.102-4.937.477-.458 1.02-.844 1.614-1.143.875-.44 1.857-.687 2.894-.687h31.982z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCECDB",
    d: "M31.744 76.719V20.54c0-3.448 2.82-6.269 6.268-6.269h33.391c3.448 0 6.269 2.821 6.269 6.269v56.178c0 3.448-2.82 6.269-6.269 6.269h-33.39c-3.449 0-6.27-2.821-6.27-6.27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M62.88 35.398c-3.529-1.325-5.314-5.259-3.99-8.786 1.325-3.528 5.258-5.315 8.787-3.99 3.528 1.325 5.314 5.26 3.99 8.787-1.325 3.527-5.26 5.314-8.787 3.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M71.667 31.409L58.89 26.612c1.324-3.528 5.257-5.315 8.786-3.99 3.528 1.325 5.314 5.26 3.99 8.787"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M39.821 34.296c-2.92-2.384-3.353-6.682-.97-9.6 2.383-2.92 6.68-3.356 9.6-.972 2.92 2.383 3.354 6.682.971 9.601-2.383 2.92-6.682 3.354-9.6.971"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M49.422 33.325l-10.571-8.63c2.383-2.919 6.68-3.355 9.6-.97 2.92 2.382 3.354 6.682.971 9.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M62.88 77.022c-3.529-1.325-5.314-5.258-3.99-8.786 1.325-3.527 5.258-5.315 8.787-3.99 3.528 1.325 5.314 5.26 3.99 8.787-1.325 3.528-5.26 5.314-8.787 3.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M71.667 73.497L58.89 68.7c1.324-3.528 5.257-5.315 8.786-3.99 3.528 1.325 5.314 5.26 3.99 8.787"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M39.821 75.92c-2.92-2.384-3.353-6.682-.97-9.6 2.383-2.92 6.68-3.355 9.6-.971 2.92 2.382 3.354 6.682.971 9.6-2.383 2.92-6.682 3.354-9.6.971"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M49.422 75.413l-10.571-8.63c2.383-2.919 6.68-3.355 9.6-.97 2.92 2.382 3.354 6.681.971 9.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M68.201 56.763c-3.406 1.615-7.474.161-9.088-3.243-1.614-3.405-.163-7.474 3.244-9.089 3.405-1.614 7.474-.161 9.088 3.244 1.614 3.405.161 7.474-3.244 9.088"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M71.445 47.675L59.113 53.52c-1.614-3.405-.163-7.474 3.244-9.089 3.404-1.614 7.474-.16 9.088 3.244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M37.802 48.062c1.4-3.5 5.372-5.2 8.87-3.8 3.498 1.4 5.2 5.37 3.8 8.87-1.4 3.499-5.373 5.2-8.871 3.8-3.498-1.4-5.2-5.372-3.8-8.87"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M41.6 56.932l5.072-12.67c3.498 1.4 5.2 5.37 3.8 8.87-1.4 3.499-5.373 5.2-8.871 3.8"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ye7ymy3jub",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nw1pu6nwba"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EF7E29",
    d: "M20.059 114.947L72.503 114.947 72.503 36.681 20.059 36.681z",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F99746",
    d: "M27.365 114.947L79.809 114.947 79.809 36.68 27.365 36.68z",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8661A",
    d: "M27.365 41.222L24.851 45.131 20.059 45.131 20.059 36.681 27.364 36.681z",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F99746",
    d: "M22.884 42.846L15.58 42.846 20.059 36.681 27.364 36.681z",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M54.413 115.197L27.365 115.197 27.365 40.247 54.413 42.846z",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF7E29",
    d: "M79.809 42.846L75.553 45.131 29.893 45.131 27.365 41.222 27.365 36.68z",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F99746",
    d: "M83.513 42.846L31.069 42.846 27.364 36.681 79.808 36.681z",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCECDB",
    d: "M62.763 114.84H6.35c-3.492 0-6.35-2.857-6.35-6.35V74.335c0-3.493 2.858-6.35 6.35-6.35h56.413c3.493 0 6.35 2.857 6.35 6.35v34.155c0 3.493-2.857 6.35-6.35 6.35",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M21.248 83.075c-1.333 3.6-5.29 5.421-8.837 4.07-3.548-1.351-5.345-5.364-4.013-8.964 1.333-3.599 5.29-5.421 8.838-4.07 3.548 1.351 5.345 5.365 4.012 8.964",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M17.236 74.11L12.41 87.146c-3.548-1.351-5.345-5.364-4.013-8.964 1.333-3.599 5.29-5.421 8.838-4.07",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M20.14 106.6c-2.398 2.979-6.72 3.42-9.657.99-2.935-2.431-3.374-6.816-.976-9.795 2.397-2.978 6.72-3.421 9.657-.99 2.935 2.43 3.372 6.817.976 9.794",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M19.163 96.805l-8.68 10.785c-2.936-2.431-3.374-6.816-.976-9.795 2.397-2.978 6.72-3.421 9.656-.99",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M63.114 83.075c-1.333 3.6-5.29 5.421-8.838 4.07-3.547-1.351-5.345-5.364-4.012-8.964 1.332-3.599 5.29-5.421 8.837-4.07 3.548 1.351 5.345 5.365 4.013 8.964",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M59.103 74.11l-4.825 13.035c-3.548-1.351-5.345-5.364-4.013-8.964 1.333-3.599 5.29-5.421 8.838-4.07",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M62.005 106.6c-2.315 2.876-6.426 3.387-9.349 1.227-.105-.074-.206-.154-.307-.238-2.937-2.43-3.374-6.814-.976-9.794 2.395-2.978 6.72-3.422 9.656-.99.1.083.196.167.291.255 2.672 2.472 3 6.662.685 9.54",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M61.32 97.06l-8.664 10.767c-.105-.074-.206-.154-.307-.238-2.937-2.43-3.374-6.814-.976-9.794 2.395-2.978 6.72-3.422 9.656-.99.1.083.196.167.291.255",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M42.737 77.647c1.624 3.475.162 7.625-3.262 9.271-3.425 1.647-7.517.167-9.141-3.309-1.623-3.474-.162-7.625 3.262-9.272 3.425-1.646 7.518-.164 9.141 3.31",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M33.596 74.337l5.879 12.581c-3.425 1.647-7.517.167-9.141-3.309-1.623-3.473-.162-7.625 3.262-9.272",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0CB",
    d: "M33.985 108.66c-3.52-1.43-5.23-5.48-3.821-9.05 1.408-3.568 5.401-5.305 8.922-3.876 3.518 1.429 5.23 5.481 3.821 9.05-1.408 3.569-5.403 5.304-8.922 3.876",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M42.907 104.784L30.164 99.61c1.408-3.57 5.401-5.306 8.922-3.877 3.518 1.429 5.23 5.481 3.821 9.05",
    mask: "url(#ye7ymy3jub)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ye7ymy3jub)",
    opacity: 0.606
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2B478B",
    d: "M51.9 17.112c0 1.377-.555 2.629-1.45 3.537-.896.908-2.13 1.472-3.487 1.472H23.65c-2.715 0-4.936-2.255-4.936-5.009 0-1.377.556-2.628 1.45-3.536.895-.907 2.128-1.47 3.486-1.47h23.313c2.715-.001 4.937 2.252 4.937 5.006",
    transform: "translate(86 92)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#699FF0",
    d: "M39.874 17.112c0 1.377-.556 2.629-1.45 3.537-.895.908-2.129 1.472-3.486 1.472H23.649c-2.714 0-4.935-2.255-4.935-5.009 0-1.377.555-2.628 1.45-3.536.895-.907 2.128-1.47 3.485-1.47h11.289c2.715-.001 4.936 2.252 4.936 5.006",
    transform: "translate(86 92)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9F3FE",
    d: "M47.358 14.795H25.12c-.385 0-.7-.32-.7-.71v-.16c0-.39.315-.71.7-.71h22.238c.385 0 .7.32.7.71v.16c0 .39-.315.71-.7.71",
    transform: "translate(86 92)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF7E29",
    d: "M32.006 2.926c.645 1.305.704 2.76.28 4.052-.423 1.292-1.328 2.42-2.614 3.075L7.574 21.287c-2.573 1.308-5.733.24-7.023-2.37-.644-1.304-.704-2.758-.282-4.05.424-1.29 1.33-2.42 2.616-3.073L24.982.56c2.573-1.309 5.735-.244 7.024 2.366",
    transform: "translate(86 92)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F99746",
    d: "M20.607 8.722c.645 1.305.704 2.759.282 4.05-.423 1.293-1.328 2.421-2.615 3.075l-10.7 5.44c-2.573 1.308-5.733.24-7.023-2.37-.644-1.304-.704-2.758-.282-4.05.424-1.29 1.33-2.42 2.616-3.073l10.7-5.44c2.573-1.308 5.733-.243 7.022 2.368",
    transform: "translate(86 92)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE2CC",
    d: "M26.616 2.783L5.538 12.574c-.364.17-.812.032-.995-.306l-.075-.139c-.183-.338-.034-.753.331-.923l21.078-9.791c.364-.17.812-.032.995.307l.075.138c.183.338.034.753-.33.923",
    transform: "translate(86 92)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMedicine);
export default __webpack_public_path__ + "static/media/no-medicine.7314982637b4809c2dc2670a07c93f78.svg";
export { ForwardRef as ReactComponent };